import React from 'react';

const Login = () => {
  return (
    <a href="https://dribbble.com/oauth/authorize?client_id=e017574f6f8a1234f57e8a13e4c887efa6f82f4bcebd6095fc2cc28abe215af3&redirect_uri=https://dribbbler-players-card.netlify.app" className="cta">Get started</a>
  )
}

export default Login;